<template>
    <div class="isFormBlock">
        <navigation-bar Close/>
        <div class="main mb-5">
            <div class="row top-banner" v-if="newPreview!==''">
                <img :src="newPreview">
            </div>
            <div class="privacy">
                <div class="row text-center">
                    <div class="store-info">主辦單位：{{organizer}}</div>
                </div>
            </div>

            <div class="top-title">
                <div class="formName" v-html="formTitle"/>
                <div class="formContent" v-html="formContent"/>
                <p class="red mt-4">「*」為必填項目</p>
            </div>

            <div class="form-box">
                <div class="li" :class="{'isTitle': item.type === 0}" v-for="(item, index) in questionnaireTopic"
                     :key="index">
                    <div v-if="item.type === topicType.TITLE" v-html="item.title" class="subtitle"/>
                    <div class="TitleBox" v-if="item.type !== topicType.TITLE">
                        {{item.title}}
                    </div>
                    <div v-if="item.type !== topicType.TITLE && item.imagePath !== ''">
                        <img :src="item.imagePath" alt="標題" class="pic">
                    </div>

                    <!--todo 是非-->
                    <div class="ReplyBox style-1" v-if="item.type === topicType.TRUE_OR_FALSE">
                        <div
                                v-for="(ans, ansIndex) in item.answerList"
                                :key="ansIndex"
                                :class="[ans.checked ? 'ans check' : 'ans']"
                        >
                            {{ans.title}}
                            <span v-if="ans.imagePath !== ''">
                                    <img :src="ans.imagePath" alt="圖片" class="pic">
                                </span>
                            <span v-if="ans.isShowInput && ans.checked">: {{ans.answerTitle}}</span>
                        </div>
                    </div>
                    <!--todo 單選-->
                    <div class="ReplyBox style-2" v-if="item.type === topicType.RADIO">
                        <div
                                v-for="(ans, ansIndex) in item.answerList"
                                :key="ansIndex"
                                :class="[ans.checked ? 'ans check' : 'ans']"
                        >
                            {{ans.title}}
                            <span v-if="ans.imagePath !== ''">
                                    <img :src="ans.imagePath" alt="圖片" class="pic">
                                </span>
                            <span v-if="ans.isShowInput && ans.checked">: {{ans.answerTitle}}</span>
                        </div>
                    </div>
                    <!--todo 星級-->
                    <div class="ReplyBox style-3" v-if="item.type === topicType.STAR">
                        <div class="StarRating">
                            <i v-for="(ans, ansIndex) in item.answerList"
                               :key="ansIndex"
                               :class="[getScoreAnswer(item.answerList, ans.title) ? 'el-icon-star-on' : 'el-icon-star-on off']"
                            ></i>
                        </div>
                    </div>
                    <!--todo 下拉選單-->
                    <div class="ReplyBox style-4" v-if="item.type === topicType.SELECT">
                        <div v-for="(ans, ansIndex) in item.answerList" :key="ansIndex"
                             v-show="ans.checked"
                             class="con">
                            {{ans.title}}
                            <span v-if="ans.imagePath !== ''">
                                    <img :src="ans.imagePath" alt="圖片" class="pic">
                                </span>
                            <span v-if="ans.isShowInput">: {{ans.answerTitle}}</span>
                        </div>
                    </div>
                    <!--todo 複選-->
                    <div class="ReplyBox style-5" v-if="item.type === topicType.MULTI_SELECT">
                        <div
                                v-for="(ans, ansIndex) in item.answerList"
                                :key="ansIndex"
                                :class="[ans.checked ? 'ans check' : 'ans']"
                        >
                            {{ans.title}}
                            <span v-if="ans.imagePath !== ''">
                                    <img :src="ans.imagePath" alt="圖片" class="pic">
                                </span>
                            <span v-if="ans.isShowInput && ans.checked">: {{ans.answerTitle}}</span>
                        </div>
                    </div>
                    <!--todo 自填、數字、日期 -->
                    <div class="ReplyBox style-6" v-if="item.type === topicType.CUSTOM ||
                                item.type === topicType.NUMBER || item.type === topicType.DATE">
                        <div
                                v-for="(ans, ansIndex) in item.answerList"
                                :key="ansIndex"
                                class="con"
                        >
                            {{ans.answerTitle}}
                        </div>
                    </div>
                    <!--todo 地址-->
                    <div class="ReplyBox style-6" v-if="item.type === topicType.ADDRESS">
                        <div
                                v-for="(ans, ansIndex) in item.answerList"
                                :key="ansIndex"
                                class="con"
                        >
                            {{addressToString(ans.answerTitle)}}
                        </div>
                    </div>
                    <!--todo 影片-->
                    <div class="ReplyBox style-6" v-if="item.type === topicType.VIDEO">
                        <div
                            v-for="(ans, ansIndex) in item.answerList"
                            :key="ansIndex"
                            class="con"
                        >
                            <div class="video-container mt">
                                <iframe :id="`store-video-frame-${ansIndex}`" width="560" height="315" :src="changeVideoUrl(ans.title)" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"/>
                            </div>
                        </div>
                    </div>
                    <!--todo 圖片-->
                    <div class="ReplyBox style-7" v-if="item.type === topicType.IMAGE">
                        <a
                            v-for="(ans, ansIndex) in item.answerList"
                            :key="ansIndex"
                            class="con"
                            @click="showImgPrevDialog(ans.answerTitle)"
                        >
                            <el-image :src="ans.answerTitle"/>
                        </a>
                    </div>
                    <!--todo 線性刻度-->
                    <div class="ReplyBox style-8" v-if="item.type === topicType.LINE_SCALE">
                        <div class="d-flex">
                            <div class="tag">{{item.label1}}</div>
                            <div class="rate">
                                <div
                                    v-for="(ans, ansIndex) in item.answerList"
                                    :key="ansIndex"
                                    :class="[getScoreAnswer(item.answerList, ans.title) ? 'el-icon-star-on' : 'el-icon-star-on off']"
                                >
                                </div>
                            </div>
                            <div class="tag">{{item.label2}}</div>
                        </div>
                        <div class="d-flex num">
                            <span v-for="(item, index) in item.answerList" :key="index">{{item.title}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <el-dialog :visible.sync="pictureCardPreviewDialogVisible"
                       class="stall-photo-pop">
                <Banner :list="fileList"
                        :fileNum="pictureCardPreviewImgIndex"
                        :is-delete="false"
                        @value-close="closePictureCardPreviewDialog"/>
            </el-dialog>

        </div>

    </div>
</template>

<script>
    import Banner from '@/components/PhotoSlider';
    // import ShowImgDialog from "@/components/ShowImgDialog";
    import * as constDefine from "@/store/constDefine";
    import city from "@/util/city";

    export default {
        name: 'FormContent',
        components: {Banner},
        data() {
            return {
                nameIsShow: true,
                nameIsRequire: true,
                phoneIsShow: true,
                phoneIsRequire: true,
                genderIsShow: true,
                newPreview: '',
                organizer: '',      //主辦單位
                formTitle: '',      //表單標題
                formContent:'',     //表單說明
                inputText: '',

                topicType: {...constDefine.TopicType},
                dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",        //url 傳來的加密參數
                dataObject: {},         //url加密參數解析後的值
                formId: 0,              //表單ID
                questionnaireTopic: [], //問題(標題)
                recordTopicList: [],    //答案選項
                recordAnswerList: [],   //user回答記錄
                fileList: [],           //留言用到的圖檔
                pictureCardPreviewImgIndex: 0,              //要預覽的圖的索引
                pictureCardPreviewDialogVisible: false,     //圖片預覽控制旗標
                imgPrevUrl: '',         //預覽圖網址
                isShowDialog: false,    //預覽圖開關
            }
        },
        created() {

        },
        mounted() {

            this.initForDataToken(this.dataToken);

        },
        methods: {
            /** 取資料 */
            setupData: function() {

                let self = this;
                // console.log(`itemList: ${JSON.stringify(itemList)}`);
                self.$http.fetchWithAuth`GetFormRecordDetail${{
                    id: self.formId,
                }} ${json => {
                    if (this.$public.notNull(json.data)) {

                        //標題和表單說明
                        if (this.$public.notNull(json.data.basicData.title)) {
                            self.newPreview = json.data.basicData.imagePath;
                            self.organizer = json.data.basicData.organizer;
                            self.formTitle = json.data.basicData.title;
                            self.formContent = json.data.basicData.content;
                        }

                        //問題的標題、回覆與選項
                        self.questionnaireTopic = json.data.topicList;
                        self.recordAnswerList = json.data.recordAnswerList;
                        self.recordTopicList = json.data.recordTopicList;

                        //整合問題與回覆的資料結構
                        for (let topic of self.questionnaireTopic) {
                            for (let recordTopic of self.recordTopicList) {
                                if (topic.id === recordTopic.id) {
                                    topic.answerList = recordTopic.answerList;
                                    if (topic.extraData !== '') {
                                        let extraData = JSON.parse(topic.extraData);
                                        topic.label1 = extraData.label1;
                                        topic.label2 = extraData.label2;
                                    }

                                    if (topic.type === constDefine.TopicType.IMAGE) {
                                        if (topic.answerList.length !== 0) {
                                            topic.answerList = self.recordAnswerList.filter(data =>
                                                data.answerId === topic.answerList[0].id)
                                        }
                                    } else if (topic.type === constDefine.TopicType.VIDEO) {
                                        let frame = document.getElementById('store-video-frame');
                                        if (this.$public.notNull(frame)) {
                                            frame.src = topic.imagePath;
                                        }
                                    } else {
                                        for (let ans of topic.answerList) {
                                            for (let recordAnswer of self.recordAnswerList) {
                                                if (ans.id === recordAnswer.answerId) {
                                                    ans.checked = true;
                                                    ans.answerTitle = recordAnswer.answerTitle;
                                                }
                                            }
                                        }
                                    }
                                    break;
                                }
                            }
                        }
                    }
                }}`;
            },


            addressToString: function(arrayString) {
                const regex = /\[(\d+),(\d+)\](.*)/;
                const matchResult = arrayString.match(regex);

                if (matchResult) {
                    const coordinates = [parseInt(matchResult[1]), parseInt(matchResult[2])];
                    const roadName = matchResult[3];
                    return city.arrayToString(coordinates)+roadName;
                } else {
                    return '';
                }
            },

            /** 替換影片 url */
            changeVideoUrl: function (url) {
                //替換 i-frame 的連結
                // let watchKey = 'watch?v=';
                // let video = 'https://www.youtube.com/embed/69arSuOXsRE?controls=0';
                // this.videoUrl = 'https://www.youtube.com/watch?v=v_RT8hLUDuo';
                // this.videoUrl = '<iframe width="560" height="315" src="'+ video +'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"/>';

                if (this.$public.notNull(url) && url !== "") {
                    let videoUrl = this.$public.getEmbedVideoUrl(url);
                    return videoUrl;
                }
            },

            /** 分數類 題型 */
            getScoreAnswer: function(answerList, ans) {
                let a = answerList.find(a => a.checked);
                if (a !== undefined) {
                    return ans <= Number(a.title);
                } else {
                    return false;
                }
            },

            /** 圖片預覽 */
            handlePictureCardPreview(file) {
                this.pictureCardPreviewImgIndex = this.fileList.indexOf(file);
                this.pictureCardPreviewDialogVisible = true;
                // console.log(`pictureCardPreviewImgIndex: ${this.pictureCardPreviewImgIndex}`);
                //彈窗要改黑色背景
                document.body.classList.add('bg-dark')
            },

            /** 關閉圖片預覽 */
            closePictureCardPreviewDialog(){
                this.pictureCardPreviewDialogVisible = false;
                //彈窗要改回預設
                document.body.classList.remove('bg-dark')
            },


            /** 顯示 ImgPrev dialog */
            async showImgPrevDialog (imgUrl) {
                this.imgPrevUrl = imgUrl;
                this.isShowDialog = true;
                try {
                    const response = await fetch(imgUrl);
                    this.fileList = [];
                    this.fileList.push(response);
                    this.handlePictureCardPreview(response);

                } catch (error) {
                    this.$public.showNotify('下載圖片失敗', false);
                    // console.log(`downloadImage error  : ${JSON.stringify(error)}`);
                }
            },

            /** 有使用加密型參數 dataToken時的初始函式 */
            initForDataToken: function(item) {
                let self = this;
                try {

                    self.dataObject = self.$crypto.uriComponentToObject(item);

                    if (self.$public.notNull(self.dataObject) &&
                        self.$public.notNull(self.dataObject.id)) {
                        self.formId = self.dataObject.id;
                        // this.isSetupList = true;
                    }
                    self.setupData();

                } catch (e) {
                    // this.$router.push({name:'Error'});
                    return false;
                }
            },

        },
    }
</script>
<style lang="less" scoped src="../../../less/form.less"/>